import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { AnnouncementModel } from '../../core/models/announcement.model';
import { AnnouncementService } from '../../modules/announcements/announcement.service';

@Component({
  selector: 'app-announcement-banner',
  templateUrl: './announcement-banner.component.html',
  styleUrls: ['./announcement-banner.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class AnnouncementBannerComponent implements OnInit, OnDestroy {
  announcement: AnnouncementModel | null = null;
  dismissed: boolean = false;
  private subscription: Subscription;

  priorityClasses = {
    low: 'alert-info',
    normal: 'alert-primary',
    high: 'alert-warning',
    urgent: 'alert-danger'
  };

  priorityIcons = {
    low: 'fa-info-circle',
    normal: 'fa-bullhorn',
    high: 'fa-exclamation-circle',
    urgent: 'fa-exclamation-triangle'
  };

  constructor(private announcementService: AnnouncementService) {
    //console.log('🔍 Banner: Constructor called');

    this.subscription = this.announcementService.currentAnnouncement$.subscribe({
      next: (ann) => {
        //console.log('🔍 Banner: Received announcement from service:', ann);
        //console.log('🔍 Banner: Announcement details:', JSON.stringify(ann));
        this.announcement = ann;
        this.dismissed = false;
      },
      error: (err) => {
        console.error('🔍 Banner: Error receiving announcement:', err);
      }
    });
  }


  ngOnInit(): void {
   // console.log('🔍 Banner: ngOnInit called');
  }

  ngOnDestroy(): void {
    //console.log('🔍 Banner: ngOnDestroy called');
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  dismiss(): void {
    //console.log('🔍 Banner: Dismiss called');
    this.dismissed = true;
  }

  getPriorityClass(): string {
    if (!this.announcement) return 'alert-info';
    return this.priorityClasses[this.announcement.priority as keyof typeof this.priorityClasses] || 'alert-info';
  }

  getPriorityIcon(): string {
    if (!this.announcement) return 'fa-info-circle';
    return this.priorityIcons[this.announcement.priority as keyof typeof this.priorityIcons] || 'fa-info-circle';
  }
}
